import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { AccumulationChartAllModule, ChartAllModule, RangeNavigatorAllModule } from '@syncfusion/ej2-angular-charts';
import { CategoriesModule } from 'apps/wsg/src/app/shared/categories/categories.module';
import { LocationsModule } from 'apps/wsg/src/app/shared/locations/locations.module';
import { WsgSharedModule }  from '@morningstar/wsg/shared';
import { BilledRevenueLineComponent } from './billed-revenue-line/billed-revenue-line.component';
import { EarnedRevenueLineComponent } from './earned-revenue-line/earned-revenue-line.component';
import { RevenueTotalService } from './revenue-total.service';

@NgModule({
  declarations: [
    EarnedRevenueLineComponent,
    BilledRevenueLineComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    WsgSharedModule,
    CategoriesModule,
    ChartAllModule, 
    RangeNavigatorAllModule, 
    ButtonModule, 
    AccumulationChartAllModule,
    LocationsModule
  ],
  providers: [
    RevenueTotalService
  ]
})
export class RevenueTotalModule { }
